import { render } from "./pay.vue?vue&type=template&id=8543f1d6"
import script from "./pay.vue?vue&type=script&lang=js"
export * from "./pay.vue?vue&type=script&lang=js"

import "./pay.vue?vue&type=style&index=0&id=8543f1d6&lang=less"

import exportComponent from "D:\\wwwroot\\tutoredin\\online-education\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__